import React from 'react';

import {RouterTabListComponent} from './styled';

export const RouterTabsContext = React.createContext('');

interface Props {
    baseUrl: string;
}

export const RouterTabList = ({baseUrl, children}: React.PropsWithChildren<Props>) => (
    <RouterTabsContext.Provider value={baseUrl}>
        <RouterTabListComponent>{children}</RouterTabListComponent>
    </RouterTabsContext.Provider>
);
